export default function Polynomial_Regression() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Polynomial_Regression</h1>
      <p>Content for Polynomial_Regression goes here.</p>
    </div>
  );
}